import { useContext } from 'react';
import useHttp from './useHttp';
import AuthContext from '../context/authContext';
import { toast } from 'react-toastify';

const usePrintserverConfig = () => {
  const authCtx = useContext(AuthContext);
  const { isLoading, error, sendRequest } = useHttp();

  const createPrintserverConfig = async ({
    entertainmentId,
    printerName,
    backendUrl,
    mqttUrlPrintserver,
    mqttUrlLocationserver,
    mqttUsername,
    mqttPassword,
    locationId,
    port,
    emergencyTotpSecret,
    onlineMqttUrl,
    onlineMqttUsername,
    onlineMqttPassword,
    localPrintEnabled,
    printCard,
    debugLevel,
    cupsCancelPendingOnRebind,
    printerCupsName,
    printerUsbPort,
    printerCupsAutofix,
  }) => {
    try {
      const responseData = await sendRequest({
        url: '/api/v1/printserver-config',
        method: 'POST',
        headers: authCtx.getAuthHeaders(),
        body: {
          entertainmentId,
          printerName: printerName || undefined,
          backendUrl: backendUrl || undefined,
          mqttUrlPrintserver: mqttUrlPrintserver || undefined,
          mqttUrlLocationserver: mqttUrlLocationserver || undefined,
          mqttUsername: mqttUsername || undefined,
          mqttPassword: mqttPassword || undefined,
          locationId: locationId || undefined,
          port: port || undefined,
          emergencyTotpSecret: emergencyTotpSecret || undefined,
          onlineMqttUrl: onlineMqttUrl || undefined,
          onlineMqttUsername: onlineMqttUsername || undefined,
          onlineMqttPassword: onlineMqttPassword || undefined,
          localPrintEnabled: localPrintEnabled ?? undefined,
          printCard: printCard ?? undefined,
          debugLevel: debugLevel ?? undefined,
          cupsCancelPendingOnRebind: cupsCancelPendingOnRebind ?? undefined,
          printerCupsName: printerCupsName || undefined,
          printerUsbPort: printerUsbPort || undefined,
          printerCupsAutofix: printerCupsAutofix ?? undefined,
        },
      });

      return responseData;
    } catch (e) {
      toast.error('Fehler beim Erstellen der Printserver-Konfiguration');
      throw e;
    }
  };

  const rotateServiceAccountSecret = async serviceAccountId => {
    try {
      const responseData = await sendRequest({
        url: `/api/v1/service-account/${serviceAccountId}/rotate-secret`,
        method: 'POST',
        headers: authCtx.getAuthHeaders(),
      });
      return responseData;
    } catch (e) {
      toast.error('Fehler beim Rotieren des Service-Accounts');
      throw e;
    }
  };

  return {
    isLoading,
    error,
    createPrintserverConfig,
    rotateServiceAccountSecret,
  };
};

export default usePrintserverConfig;

